import React from 'react';
import { useSecurity } from '../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../helpers/Utils';

export function IntegrationAuditMessagePage(): React.ReactElement {
  const currentSecurity = useSecurity('Integration', 'AuditMessage');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Integration/Scripts/Resources/en/res.AuditMessage.en.js",
        "Areas/Integration/Scripts/Resources/en/Types.en.js",
        "Areas/Integration/Scripts/Enums.js",
        "Areas/Integration/Scripts/AuditMessage/Index.js"], "initIntegrationAuditMessage", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
